module.exports = __webpack_public_path__ + "img/storage_three.edbb97fd.jpg";